import markPng from "@/assets/vivelo-mark.png";
import wordmarkLight from "@/assets/vivelo-wordmark-light.png";
import wordmarkDark from "@/assets/vivelo-wordmark-dark.png";

type LogoProps = {
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "onDark" | "onLight";
  showTag?: boolean;
};

// Alturas del logo (marca) y del texto "VÍVELO AI".
const sizeMap = {
  sm: { mark: "h-8", word: "h-4", tag: "text-[9px]" },
  md: { mark: "h-11", word: "h-[22px]", tag: "text-[10px]" },
  lg: { mark: "h-16", word: "h-8", tag: "text-xs" },
  xl: { mark: "h-24", word: "h-12", tag: "text-sm" },
};

/**
 * Logo oficial de Vívelo AI: la marca (la V con la persona y la estrella) junto
 * al texto "VÍVELO AI". Sobre fondo oscuro el texto es blanco; sobre fondo claro
 * es azul profundo (la marca y "AI" mantienen sus colores).
 */
export default function Logo({ size = "md", variant = "onDark", showTag = false }: LogoProps) {
  const s = sizeMap[size];
  return (
    <div className="inline-flex items-center gap-2.5 select-none" aria-label="Vívelo AI">
      <img src={markPng} alt="" className={`${s.mark} w-auto flex-shrink-0`} draggable={false} />
      <div className="flex flex-col leading-none">
        <img src={variant === "onDark" ? wordmarkLight : wordmarkDark} alt="Vívelo AI" className={`${s.word} w-auto`} draggable={false} />
        {showTag ? (
          <span className={`${s.tag} mt-1.5 tracking-[0.25em] ${variant === "onDark" ? "text-foreground-300" : "text-foreground-600"} uppercase`}>
            Descubre · Aprende · Crece · Comparte · Vívelo
          </span>
        ) : null}
      </div>
    </div>
  );
}
